export default function calculatePerBreakpoint(perBreakpoint = { }, callback) {
  return Object.keys(perBreakpoint).reduce((style, breakpoint) => {
    style['@media (min-width: ' + breakpoint + 'px)'] = callback(perBreakpoint[breakpoint])
    return style
  }, { })
}



// WEBPACK FOOTER //
// ../utils/calculatePerBreakpoint.js